import React, { useEffect } from 'react';
import { initMetaPixel, trackPixelEvent } from './utils/metaPixel';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { PackContents } from './components/PackContents';
import { Workflow } from './components/Workflow';
import { FitCheck } from './components/FitCheck';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { ClosingCTA } from './components/ClosingCTA';
import { Disclaimer } from './components/Disclaimer';
import { Footer } from './components/Footer';
import { CURRENCY, PRICE_VALUE, PRODUCT_NAME } from './components/Shared';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPixelEvent('ViewContent', {
      content_name: PRODUCT_NAME,
      content_type: 'product',
      value: PRICE_VALUE,
      currency: CURRENCY
    });
  }, []);
  return <div lang="en" className="min-h-screen w-full overflow-x-hidden rice-paper-soft font-sans text-stone-900 antialiased selection:bg-emerald-100 selection:text-emerald-900" data-id="element-0" data-mp="23u9v6r043jyv">
      <AnnouncementBar data-id="element-1" data-mp="3mkrgru1fnxhj" />
      <main data-id="element-2" data-mp="3mjzu58ptda3e">
        <Hero data-id="element-3" data-mp="3mjg9vlcoy9m7" />
        <PackContents data-id="element-4" data-mp="3mj6jhwnqi0fz" />
        <Workflow data-id="element-5" data-mp="3rbra6pbcfxfa" />
        <FitCheck data-id="element-6" data-mp="3rdaq2et386gj" />
        <Pricing data-id="element-7" data-mp="3rcsw5otwe4bs" />
        <FAQ data-id="element-8" data-mp="3recd7hndojem" />
        <ClosingCTA data-id="element-9" data-mp="5yk6vxnnffx" />
        <Disclaimer data-id="element-10" data-mp="6hr7hlrojf6" />
      </main>
      <Footer data-id="element-11" data-mp="4n7g6m8exco" />
    </div>;
}